import React, { useMemo } from 'react';
import { IDeliveryType } from '../../../models/configuration/plugin/IConfiguration';
import {
    StyledEmptyStateDiv
} from './DeliveryTypesList.styles';
import { DtArrangebleList, TreeItem } from '../../ui/list/DtArrangebleList';
import { DtListItem } from '../../ui/list';
import { Box, Divider } from '@mui/material';
import DtAlert from '../../ui/alert/DtAlert';

interface DeliveryTypesListProps {
    deliveryTypes: IDeliveryType[] | null,
    selectedDeliveryTypeIdx: string | null,
    selectDeliveryType: (id: string) => void,
    deliveryTypeTree: any[] | null,
    onListOrderChange?: (event: { parent: string | null, arrangedItems: { item: string | number, Order: number }[] }) => void
}


// Helper to convert tree to DtListItem[]
const toDtListItems = (
    nodes: any[],
    selectedDeliveryTypeIdx: string | null,
    selectDeliveryType: (id: string) => void
): DtListItem[] => {
    return nodes.map(node => ({
        id: node.Id,
        label: node.Caption ?? node.Id,
        checked: selectedDeliveryTypeIdx === node.Id,
        disabled: !node.Enabled,
        onClick: () => selectDeliveryType(node.Id),
        Order: node.Order, 
        children: node.children
            ? node.children.map((dtc: any) => ({
                id: dtc.Id,
                label: dtc.Caption ?? dtc.Id,
                checked: selectedDeliveryTypeIdx === dtc.Id,
                disabled: !dtc.Enabled,
                onClick: () => selectDeliveryType(dtc.Id),
                Order: dtc.Order,
            }))
            : undefined
    }));
};

const DeliveryTypesList: React.FC<DeliveryTypesListProps> =
    ({selectedDeliveryTypeIdx, selectDeliveryType, deliveryTypeTree, onListOrderChange}) => {
        // Memoize items for performance
        const items = useMemo(() =>
            deliveryTypeTree
                ? toDtListItems(deliveryTypeTree, selectedDeliveryTypeIdx, selectDeliveryType)
                : []
        , [deliveryTypeTree, selectedDeliveryTypeIdx, selectDeliveryType]);

        return (
            <Box>
                <Box sx={{ 
                    maxHeight: { md: '52vh', lg: '66vh', xl: '76vh' }, 
                    overflowY: 'auto'
                }}>
                    <DtAlert severity='info'>
                        Drag items to rearrange.
                    </DtAlert>
                    {deliveryTypeTree &&
                        (deliveryTypeTree.length === 0 ?
                            <StyledEmptyStateDiv>No delivery types found</StyledEmptyStateDiv>
                            :
                        <Box sx={{ pr: 0.5}}>
                            <DtArrangebleList
                                items={items}
                                selectable={false}
                                dense={false}
                                onArrange={event => {
                                    if (typeof onListOrderChange === 'function') {
                                        onListOrderChange(event);
                                    }
                                }}
                                onClick={(item: TreeItem) => {
                                    selectDeliveryType(item.id as string);
                                }}
                                collapsibleChildren={true}
                                defaultExpanded={false}
                                syncOnChange={false}
                            />
                        </Box>
                        )}
                </Box>
            </Box>
        );
    }

export default DeliveryTypesList;